import { createServerFn } from "@tanstack/react-start";

export const getTraumaGate = createServerFn({ method: "GET" }).handler(async () => {
  const { isTraumaEnabled } = await import("@/lib/trauma/gate.server");
  const { requestIsAdmin } = await import("@/lib/bousala/smart-preview.server");
  const [enabled, isAdmin] = await Promise.all([isTraumaEnabled(), requestIsAdmin()]);
  return { enabled, isAdmin, canView: enabled || isAdmin };
});
